import { useMemo } from "react"
import { Box, CardMedia, useTheme } from "@mui/material"
import { size } from "lodash"
import { deepmerge } from "@mui/utils"
import { Carousel, CarouselItem } from "components/Carousel"
import { ImageCarouselModal } from "components/Image"
import { useImageModal } from "hooks/imageModal/useImageModal"

export const GalleryCarousel = ({
  sx = {},
  images = [],
  carouselOptions = {},
  ...props
}) => {
  const theme = useTheme()
  const { styleOverrides = {} } = theme.components[`GalleryCarousel`] || {}
  const { root, galleryCarousel, galleryCarouselItem } = styleOverrides
  const { handleImage, openModal, activeImage, handleClose } = useImageModal()
  const galleryUrls = useMemo(
    () => (size(images) > 0 ? images?.map((image) => image?.url) : []),
    [images]
  )

  const { galleryCarouselOption } =
    theme.components[`GalleryCarousel`]?.defaultProps || {}

  return (
    <>
      <Box sx={deepmerge(root, sx)} {...props}>
        <Carousel
          options={{
            type: "loop",
            padding: 0,
            gap: 8,
            pagination: true,
            autoplay: true,
            ...carouselOptions,
          }}
          className="GalleryCarousel-galleryCarousel"
          sx={galleryCarousel}
        >
          {images.map(({ id, url }) => {
            return (
              <CarouselItem key={`slide-${id}`} sx={galleryCarouselItem}>
                <CardMedia
                  component="img"
                  sx={galleryCarouselItem}
                  src={url}
                  onClick={() => handleImage(url)}
                />
              </CarouselItem>
            )
          })}
        </Carousel>
      </Box>
      <ImageCarouselModal
        activeSrc={activeImage}
        open={openModal}
        imageSrcs={galleryUrls}
        onClose={handleClose}
        carouselOptions={galleryCarouselOption}
      />
    </>
  )
}
